module.exports = __webpack_public_path__ + "static/2-d7cd2d300583668cf9d0a867666eb752.jpg";